import { gql } from 'urql';

export const VXLTextFragment = gql`
  fragment VXLTextFragment on VXLText {
    __typename
    copy
    style {
      fontStyle
      color
    }
  }
`;

export const VXLResponsiveTextFragment = gql`
  fragment VXLResponsiveTextFragment on VXLText {
    copy
    style {
      fontStyle
      color
    }
  }
`;

export const IconFragment = gql`
  fragment IconFragment on IconStyleDictionary {
    id
    fallbackURL
    iconKey
    tint
  }
`;
